<template>
    <layout>
        <rdkm-title>
            {{ $t('Разрешенные значения в локусах') }}
            <router-link tag="span" to="/validLocuses/add">
                <b-button class="float-right" right size="sm" variant="primary">
                    <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
                </b-button>
            </router-link>
        </rdkm-title>
        <div class="tile">            
            <rdkm-grid ref="grid" :state="query">
                <grid-column name="EDIT" cell="edit-cell"></grid-column>
                <grid-column name="code" :title="$t('Код')"></grid-column>
                <grid-column name="hla" :title="$t('HLA')"></grid-column>                
                <grid-column name="DELETE" cell="delete-cell"></grid-column>              
            </rdkm-grid>
        </div>
    </layout>
</template>

<script>
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";

export default {
  name: "ValidLocuses",
  props: ["query"],
  components: {
    "rdkm-grid": Grid,
    "grid-column": GridColumn
  }
};
</script>
